import { getProviderTokenFromMicrosoft, msLoginPopup, msLoginSSO } from '../authProviders/microsoft';
import { AuthProviderType, getAuthProvider } from '../authProviders/utilities';

import { getCachedProviderToken, getTokensFromProviderToken } from '../services/identityService';

/**
 * Get id token via login window from a provider specified in the configuration
 * 
 * @returns {ProviderToken|null} - ProviderToken object with id token property if login is authenticated through a provider, null if not
 */
export const getTokensFromLogin = async () => {
    const authProvider = getAuthProvider();
    if (authProvider === AuthProviderType.Microsoft) {
        return msLoginPopup();
    } else if (authProvider === AuthProviderType.Google) {
        window.google.accounts.id.prompt();
    } 
    return null;
}

/**
 * Get id token via Single Sign On from a provider specified in the configuration without needing to re-authenticate
 * 
 * SSO is enabled by default for Microsoft accounts, But SSO must be enabled for Google accounts
 * 
 * @param {GUID} appId - ApplicationId
 * @returns {ProviderToken|null} - ProviderToken object with id token property if login is authenticated through a provider, null if not
 */
export const getTokensFromSSO = async (appId) => {
    let providerToken;
    const authProvider = getAuthProvider();

    if (authProvider === AuthProviderType.Microsoft) {
        providerToken = getCachedProviderToken();
        if (!providerToken) {
            const msToken = await msLoginSSO();
            providerToken = getProviderTokenFromMicrosoft(msToken);
        }
    } else if (authProvider === AuthProviderType.Google) {
        //Google Auth SSO not supported atm... get from cache
        providerToken = getCachedProviderToken();
    }

    if (providerToken) {
        return getTokensFromProviderToken(appId, authProvider, providerToken);
    }

    return null;
}